function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect } from "react-native-svg";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 53 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Rect, {
    x: 21,
    width: 10,
    height: 50,
    rx: 3,
    fill: props.fill
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 33.234,
    y: 55.163,
    width: 10,
    height: 37,
    rx: 3,
    transform: "rotate(135 33.234 55.163)",
    fill: props.fill
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 26.163,
    y: 62.234,
    width: 10,
    height: 37,
    rx: 3,
    transform: "rotate(-135 26.163 62.234)",
    fill: props.fill
  }));
}

export default SvgArrowDown;